"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SmallMultiples = exports.DEFAULT_SM_PANEL_PADDING = void 0;
var chart_types_1 = require("../chart_types");
var spec_factory_1 = require("../state/spec_factory");
var constants_1 = require("./constants");
exports.DEFAULT_SM_PANEL_PADDING = { outer: 0, inner: 0.1 };
var DEFAULT_SMALL_MULTIPLES_PROPS = {
    id: '__global__small_multiples___',
    chartType: chart_types_1.ChartType.Global,
    specType: constants_1.SpecType.SmallMultiples,
};
exports.SmallMultiples = (0, spec_factory_1.getConnect)()((0, spec_factory_1.specComponentFactory)(DEFAULT_SMALL_MULTIPLES_PROPS));
//# sourceMappingURL=small_multiples.js.map